export default "__VITE_ASSET__BMXgUfIW__"